module.exports = __webpack_public_path__ + "img/background.bd07a1db.jpg";